import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import {StandardTypography} from 'patient-ping-remedy/packages/typography';
import {EditorContent} from '@tiptap/react';

export const Wrapper = styled.div`
  display: flex;
  background: ${colors.white};
  border: 1px solid ${colors.gray3};
  border-radius: 8px;
`;

export const IconButtonWrapper = styled.div`
  flex-shrink: 0;
  padding: ${sizes.xxSmall};
`;

export const ContentWrapper = styled(StandardTypography)`
  flex: 1;
`;

export const contentStyles = css`
  p {
    margin: ${sizes.xSmall} 0;
  }

  .suggestion,
  [data-type="mention"] {
    color: ${colors.blue4};
  }
`;

export const ContentEditable = styled(EditorContent)`
  & > [contenteditable] {
    overflow: auto;
    word-break: break-word;
    outline: none;
    height: 100%;
    max-height: 20rem;
    padding: ${sizes.xxSmall} 0;

    p.is-editor-empty:first-of-type::before {
      color: ${colors.gray3};
      content: attr(data-placeholder);
      float: left;
      height: 0;
      pointer-events: none;
    }

    ${contentStyles}
  }
`;

export const Attachments = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${sizes.xSmall};
  margin-bottom: 1.6rem;
`;

export const Toolbar = styled.div`
  display: flex;
  gap: ${sizes.xxSmall};
  padding: ${sizes.xxSmall} ${sizes.xxSmall} 0 ${sizes.xxSmall};
  border: 1px solid transparent;
`;
